import React, {useState} from 'react';
import {Autocomplete} from '@material-ui/lab';
import {TextField, CircularProgress} from '@material-ui/core';
import recruiterCodeApi from 'Users/api/recruiterCodeApi';
import {Async, Empty, Loading, Loaded, toEither} from 'Core/models/Async';
import * as E from 'fp-ts/lib/Either';
import {RecruiterCode} from 'Users/models/User/Agent/RecruiterCode';
import './RecruiterCodeInput.sass';
import {RecruiterCodeDto} from 'Users/api';
import {EmptyRecruiterCode} from 'Agent/Policies/models/RecruiterCode';

type RecruiterCodeInputProps = {
  label: string;
  className?: string;
  recruiterCode: RecruiterCode;
  onChange: (recruiterCode: RecruiterCodeDto) => void;
  disabled?: boolean;
};

const RecruiterCodeInput = (props: RecruiterCodeInputProps) => {
  const {recruiterCode, onChange, className, label, disabled} = props;
  const [open, setOpen] = useState(false);
  const [recruiterCodeSuggestions, setRecruiterCodeSuggestions] = useState<Async<RecruiterCodeDto[]>>(new Empty());
  const searchRecruiterCodes = (codeToSearchFor?: string) => {
    if (codeToSearchFor) {
      setRecruiterCodeSuggestions(new Loading());

      recruiterCodeApi
        .searchRecruiterCodes(codeToSearchFor)
        .then(
          E.bimap(setRecruiterCodeSuggestions, recruiterCodeSuggestions =>
            setRecruiterCodeSuggestions(new Loaded(recruiterCodeSuggestions.map(code => code)))
          )
        )
        .catch(() => {});
    }
  };
  const suggestionValues = E.getOrElse((): RecruiterCodeDto[] => [])(toEither(recruiterCodeSuggestions));

  return (
    <Autocomplete
      id="recruiter-code"
      className={`recruiter-code-input ${className}`}
      open={open}
      onOpen={() => setOpen(true)}
      onClose={() => setOpen(false)}
      options={suggestionValues}
      loading={recruiterCodeSuggestions instanceof Loading}
      value={recruiterCode}
      getOptionSelected={(option, selectedRecruiterCode) => option.value === selectedRecruiterCode.value}
      getOptionLabel={option => option.value!}
      renderOption={option => option.value}
      onInputChange={(e, newInputValue) => searchRecruiterCodes(newInputValue)}
      onChange={(e, recruiterCodeSelection) => {
        onChange(recruiterCodeSelection || (EmptyRecruiterCode as any));
      }}
      renderInput={params => (
        <TextField
          {...params}
          label={label}
          fullWidth
          variant="outlined"
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {recruiterCodeSuggestions instanceof Loading ? (
                  <CircularProgress className="recruiter-code-input__loading-icon" color="inherit" size={30} />
                ) : null}
              </>
            ),
          }}
        />
      )}
      disabled={!!disabled}
    />
  );
};

export default RecruiterCodeInput;
